/**
 * caseConvert.js — pure, zero-dependency snake_case <-> camelCase helpers.
 *
 * WHY THIS OWN FILE (ISP-9999 gallery-pill-gif, qa-validator fix 2026-07-20):
 * `convertSnakeToCamel` originally lived in src/utils/helpers.js, a kitchen-
 * sink barrel that transitively imports react-froala-wysiwyg + its CSS
 * (src/components/FroalaEditor -> .../TextRichField.jsx -> .../CodeBlocks ->
 * src/constants/segmentTools.js -> src/utils/helpers.js). Jest's default CSS
 * handling can't parse that CSS as JS, so ANY test file whose import graph
 * reaches helpers.js without an explicit jest.mock() blows up — confirmed
 * live: adding `import { convertSnakeToCamel } from "../../utils/helpers"`
 * to segmentPaletteFromFill.js broke ExploreWheelCard.wheel-art.test.jsx
 * (`convertSnakeToCamel is not a function`, the test's pre-existing
 * utils/helpers mock never anticipated this new dependency) and made
 * segmentPaletteFromFill.test.js itself fail to even parse.
 *
 * Fix: extract the pure function to its own dependency-free module.
 * src/utils/helpers.js re-exports it (see below) so every EXISTING import of
 * `convertSnakeToCamel` from "utils/helpers" (e.g. pages/ViewWheel/index.jsx)
 * keeps working, byte-identical, zero risk. New code (this PR's
 * segmentPaletteFromFill.js) imports directly from here instead, so it never
 * touches the Froala-laden barrel at all.
 */

/** Shallow snake_case -> camelCase key conversion. Non-null objects only. */
export function convertSnakeToCamel(obj) {
  if (typeof obj !== "object" || obj === null) {
    throw new Error("Input should be a non-null object");
  }

  const camelCaseObj = {};
  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const camelKey = key.replace(/_[a-z]/g, (match) =>
        match[1].toUpperCase()
      );
      camelCaseObj[camelKey] = obj[key];
    }
  }
  return camelCaseObj;
}
